import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/vhe/auxiliaries/maintenance-task-types/list/all`)
    },
}